/*requires promise.min.js */

function RESTService(routePrefixOrOptions) {
  var restService = this;

  var routePrefix;
  restService.__baseUrl = null;

  if (routePrefixOrOptions && routePrefixOrOptions.constructor === Object) {
    routePrefix = routePrefixOrOptions.routePrefix;

    if (routePrefixOrOptions.baseUrl) {
      restService.__baseUrl = HEIJS.context.convertToContextUri(
        routePrefixOrOptions.baseUrl.replace(/\/$/, "")
      );
    }
  } else {
    routePrefix = routePrefixOrOptions;
  }

  restService.__usernameHash = $("input#__UsernameHash").val();

  if (routePrefix) {
    while (routePrefix[routePrefix.length - 1] === "/") {
      routePrefix = routePrefix.substr(0, routePrefix.length - 1);
    }

    restService.__routePrefix = /^https?:\/\//i.test(routePrefix)
      ? HEIJS.context.convertToContextUri(routePrefix)
      : routePrefix[0] === "/"
      ? routePrefix
      : "/" + routePrefix;
  }

  restService.__whenReady = $.Deferred();
  restService.__whenReady.resolve();

  return restService;
}

RESTService.prototype.isRESTService = true;

RESTService.prototype.RESTVerb = Object.freeze({
  Create: "POST",
  Get: "GET",
  Update: "PUT",
  Delete: "DELETE",
  Check: "HEAD",
});

window.RESTVerb = RESTService.prototype.RESTVerb;

RESTService.prototype.ReturnType = Object.freeze({
  JSON: "json",
  HTML: "html",
  Image: "image",
});

window.RESTServiceReturnType = RESTService.prototype.ReturnType;

RESTService.prototype.__accepts = {};
RESTService.prototype.__accepts[RESTService.prototype.ReturnType.JSON] =
  "application/json";
RESTService.prototype.__accepts[RESTService.prototype.ReturnType.HTML] =
  "text/html";
RESTService.prototype.__accepts[RESTService.prototype.ReturnType.Image] =
  "image/*";
Object.freeze(RESTService.prototype.__accepts);

RESTService.prototype.Url = function (route, data, type) {
  if (this.__accepts.hasOwnProperty(data)) {
    type = data;
    data = null;
  }

  return this.__createRequestOptions(
    type || this.RESTVerb.Update,
    route,
    data,
    null,
    { returnOnlyUrl: true }
  );
};

RESTService.prototype.Create = function (route, data, returnType, options) {
  return this.Call(this.RESTVerb.Create, route, data, returnType, options);
};

RESTService.prototype.Get = function (route, data, returnType, options) {
  return this.Call(this.RESTVerb.Get, route, data, returnType, options);
};

RESTService.prototype.Update = function (route, data, returnType, options) {
  return this.Call(this.RESTVerb.Update, route, data, returnType, options);
};

RESTService.prototype.Delete = function (route, data, returnType, options) {
  return this.Call(this.RESTVerb.Delete, route, data, returnType, options);
};

RESTService.prototype.Check = function (route, data, returnType, options) {
  return this.Call(this.RESTVerb.Check, route, data, returnType, options);
};

RESTService.prototype.Upload = function (route, files, options) {
  var opts = options || {};

  if (!opts.upload) {
    opts.upload = true;
  }

  return this.Call(this.RESTVerb.Create, route, files, null, opts);
};

RESTService.prototype.Call = function (type, route, data, returnType, options) {
  var restService = this;

  var abort = null;
  var promise = new Promise(function (resolve, reject) {
    restService.__whenReady.always(function () {
      var ajaxOptions = restService.__createRequestOptions(
        type,
        route,
        data,
        returnType,
        options
      );

      var request = restService.__request(ajaxOptions);
      abort = request.abort;

      request
        .then(function (response) {
          if (response.ok) {
            var contentType = response.headers.get("content-type");

            if (contentType && /application\/json/i.test(contentType)) {
              return response.json();
            }

            return response.blob();
          }

          //if (response.status === 401 && restService.isLocalhost()) {
          //  // NOTE: If this becomes a problem, we can take it out. Or we can fix it up to only do it once
          //  //       and then throw errors as normal after that. Would probably need to send some query param
          //  //       that flips a bool on the server, then sends down that bool in a hidden input or something.

          //  window.location = (restService.getBaseUrl() + '/Login.aspx?ReturnUrl=' + encodeURIComponent(window.location.href));
          //}
          else {
            var contentType = response.headers.get("content-type");

            if (contentType && /application\/json/i.test(contentType)) {
              throw response.json();
            }

            throw new Error(
              "ERROR: Network response was " +
                response.status +
                " - " +
                response.statusText
            );
          }
        })
        .then(function (result) {
          resolve(result);
        })
        .catch(function (err) {
          if (err instanceof Error || typeof err === "string") {
            reject(err);
          } else {
            err.then(reject);
          }
        });
    });
  });

  promise.abort = abort;

  return promise;
};

RESTService.prototype.__request = function (ajaxOptions) {
  var restService = this;

  var headers = new Headers();

  if (ajaxOptions.contentType) {
    headers.append("Content-Type", ajaxOptions.contentType);
  }

  headers.append("Accept", "application/json");

  for (var customHeader in ajaxOptions.headers) {
    if (ajaxOptions.headers.hasOwnProperty(customHeader)) {
      headers.append(customHeader, ajaxOptions.headers[customHeader]);
    }
  }

  var url = ajaxOptions.url;
  var body = null;

  if (ajaxOptions.type === "GET" || ajaxOptions.type === "HEAD") {
    url += restService.__createQueryString(ajaxOptions.data);
  } else {
    if (ajaxOptions.upload) {
      body = new FormData();

      for (var i = 0; i < ajaxOptions.data.length; i++) {
        var file = ajaxOptions.data[i];
        body.append("files[]", file, file.name);
      }
    } else {
      body = JSON.stringify(ajaxOptions.data);
    }
  }

  if (url.length > 2048) {
    return Promise.reject(
      "The URL is too long. In order to stay compatible with IE, URLs must be shorter than 2048 characters in length (the current URL is " +
        url.length +
        " characters long). If this is beyond your control, you should probably switch to a POST request"
    );
  }

  var fetchParams = {
    method: ajaxOptions.type,
    headers: headers,
    credentials: "include",
  };

  if (body) {
    fetchParams["body"] = body;
  }

  return abortableFetch(url, fetchParams);
};

RESTService.prototype.__getEncodedKeyValuePairs = function (obj, parentKeys) {
  var restService = this;

  var keys = Object.keys(obj);

  if (!parentKeys) {
    parentKeys = [];
  }

  var keyValuePairs = [];

  var getEncodedKey = function (key, arrayIndex) {
    var parentChain = "";

    if (parentKeys.length > 0) {
      parentChain = parentKeys
        .map(function (parentKey, i) {
          return i === 0 ? parentKey : "[" + parentKey + "]";
        })
        .join("");
    }

    var key = parentChain + (parentChain ? "[" + key + "]" : key);

    if (arrayIndex !== undefined) {
      key += "[" + arrayIndex + "]";
    }

    return encodeURIComponent(key);
  };

  var getEncodedValue = function (value) {
    // this regex is from here: https://github.com/honeinc/is-iso-date
    var isoDateRegExp = new RegExp(
      /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/
    );
    var dt = null; //store date values in a moment object we can use to format it into a string
    if (value instanceof moment) {
      dt = value;
    } else if (value instanceof Date || isoDateRegExp.test(value)) {
      //check if it is a native date or iso string, which are natively supported
      dt = moment(value);
    } else if (moment(value, "MM/DD/YYYY", true).isValid()) {
      //check for this particular date format which we use in many places, and pass moment the format so it doesn't complain
      dt = moment(value, "MM/DD/YYYY");
    }
    return encodeURIComponent(dt ? dt.format("MM/DD/YYYY h:mm A") : value);
  };

  keys.forEach(function (key) {
    if (obj[key] === null || obj[key] === undefined) {
      keyValuePairs.push([getEncodedKey(key), null]);
    } else if (obj[key].constructor === Object) {
      var arrayParentKeys = parentKeys.slice(0);
      arrayParentKeys.push(key);

      keyValuePairs = keyValuePairs.concat(
        restService.__getEncodedKeyValuePairs(obj[key], arrayParentKeys)
      );
    } else if (obj[key].constructor === Array) {
      for (var i = 0; i < obj[key].length; i++) {
        if (obj[key][i] === null || obj[key][i] === undefined) {
          keyValuePairs.push([getEncodedKey(key, i), "null"]);
        } else if (obj[key][i].constructor === Object) {
          var arrayParentKeys = parentKeys.slice(0);
          arrayParentKeys.push(key);
          arrayParentKeys.push(i + "");

          keyValuePairs = keyValuePairs.concat(
            restService.__getEncodedKeyValuePairs(obj[key][i], arrayParentKeys)
          );
        } else {
          keyValuePairs.push([
            getEncodedKey(key, i),
            getEncodedValue(obj[key][i]),
          ]);
        }
      }
    } else {
      keyValuePairs.push([getEncodedKey(key), getEncodedValue(obj[key])]);
    }
  });

  return keyValuePairs;
};

RESTService.prototype.__createQueryString = function (params) {
  var restService = this;

  if (!params) {
    return "";
  }

  return (
    "?" +
    restService
      .__getEncodedKeyValuePairs(params)
      .map(function (kvp) {
        return kvp[0] + "=" + (kvp[1] === null ? "" : kvp[1]);
      })
      .join("&")
  );
};

RESTService.prototype.isLocalhost = function () {
  return /localhost/i.test(window.location.host);
};

RESTService.prototype.getBaseUrl = function () {
  // NOTE: restServiceBaseUrl is an optional global js variable that a page can specify (we would
  //       probably do it at a template or layout level) to specify which site webpack-dev-server
  //       should route requests to. If nothing is specified, default to the intranet.
  //
  //       This only applies to when you're running an app in webpack-dev-server.

  var restService = this;

  if (restService.__baseUrl) {
    return restService.__baseUrl;
  }

  var baseUrl =
    typeof restServiceBaseUrl !== "undefined" && restServiceBaseUrl
      ? restServiceBaseUrl.replace(/\/$/, "")
      : "https://inet.dev.hendersonengineers.com";

  return HEIJS.context.convertToContextUri(baseUrl);
};

RESTService.prototype.__createRequestOptions = function (
  httpVerb,
  route,
  data,
  returnType,
  options
) {
  var restService = this;

  if (restService.__accepts.hasOwnProperty(data)) {
    returnType = data;
    data = null;
  }

  returnType = returnType || restService.ReturnType.JSON;

  if (!restService.__accepts.hasOwnProperty(returnType)) {
    throw 'returnType can only be "json", "html", or "image". Please use the ReturnType enum to avoid further confusion.';
  }

  var opts = options || {};
  var timeout = opts["timeout"] || 0;
  var returnOnlyUrl = opts["returnOnlyUrl"] || false;
  var upload = opts["upload"] || false;
  var accessToken = HEIJS.getAccessToken();

  var requestOptions = {
    type: httpVerb,
    accepts: restService.__accepts,
    dataType: returnType,
    timeout: timeout,
    upload: upload,
    headers: {
      user: restService.__usernameHash,
      Authorization: "Bearer " + accessToken,
    },
  };

  if (!upload) {
    requestOptions.contentType = "application/json";
  }

  var signalRConnectionIds = signalRUtils.getAllConnectionIds();

  if (signalRConnectionIds.length > 0) {
    requestOptions.headers["SignalRConnectionIds"] =
      signalRConnectionIds.join("|");
  }

  var url = route.constructor === Array ? route.shift() : route;

  if (
    restService.__routePrefix &&
    url.indexOf(restService.__routePrefix) === -1
  ) {
    url = restService.__routePrefix + "/" + url;
  }

  if (restService.__baseUrl || restService.isLocalhost()) {
    url = restService.getBaseUrl() + url;
  }

  if (route.constructor === Array) {
    for (var i = 0; i < route.length; i++) {
      var serializedData = JSON.stringify(route[i]);

      if (serializedData[0] === '"') {
        serializedData = serializedData.slice(1, -1);
      }

      url += "/" + encodeURIComponent(serializedData);
    }
  }

  if (data) {
    var isGetOrHead =
      httpVerb.toLowerCase() === restService.RESTVerb.Get.toLowerCase() ||
      httpVerb.toLowerCase() === restService.RESTVerb.Check.toLowerCase();
    var keys = isGetOrHead ? null : Object.keys(data);
    var dataToPass =
      !upload && keys && keys.length === 1 ? data[keys[0]] : data;

    requestOptions.data = dataToPass;
  }

  var splitUrl = url.split("://");

  if (splitUrl.length > 1) {
    splitUrl[1] = splitUrl[1].replace(/\/\//g, "/");
    requestOptions.url = splitUrl.join("://");
  } else {
    requestOptions.url = splitUrl[0].replace(/\/\//g, "/");
  }

  return !!returnOnlyUrl ? requestOptions.url : requestOptions;
};
